<template lang="pug">
.bg-page
  .container
    .tickets-warning(v-if="ticketsWarning", style="margin-top:30px")
      h3 注意事項
      h4(style="color: #fff;") 「團體票」 與 「團體潛水票」 將於 9/04 中午12:00 開賣，請密切注意
      p
        |WirForce 官方販售 BYOC 門票不會額外收取報名服務費，欲報名者請以官方釋出的座位與消息為主。
        br
        |WirForce BYOC 進場門票採實名制登記，活動期間需驗證身分證件入場，若與他人協商座位導致當天無法進場，後果恕請自行負責。
        .btn.ghost-btn.red(@click="ticketsWarning = !ticketsWarning") 關閉
    flowStep(:flow="flow")
    .step-title(v-for="(step, key) in flow.steps", v-if="flow.actived == key")
      .circle
        .number {{ key }}
      h1 {{ step }}
    .contents
      router-view
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'
import flowStep from '@/components/tickets/flowStep'

export default {
  name: 'tickets',
  components: {
    'flowStep': flowStep
  },
  data () {
    return {
      ticketsWarning: true,
      flow: {
        actived: 1,
        steps: {
          1: '請選擇購票方案',
          2: '填寫報名資料',
          3: '報名資料已成功送出'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getTicketType'])
  },
  updated () {
    if (this.getTicketType.type !== undefined) {
      switch (this.getTicketType.type) {
        case 'single':
          this.flow.steps[2] = this.getTicketType.desc + ' - 填寫報名資料'
          break
        case 'group':
          this.flow.steps[2] = this.getTicketType.desc + ' - 填寫報名資料'
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
$bar-width: 20px
$dark: #484b53
.container
  margin-top: 50px
.step-title
  .circle
    float: left
    position: relative
    background-color: #fff
    +border-radius(50%)
    width: 24px
    height: 24px
    display: inline-block
    text-align: center
    margin-right: 8px
    .number
      color: $black
      line-height: 24px
  h1
    font-size: 26px
    line-height: 24px
.contents
</style>



// WEBPACK FOOTER //
// tickets.vue?632b6ed9